import { ShapeAll } from '../../themes/default/shape/index.js';
import { ShapeTokensAll } from '../../themes/default/shape/shape-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeShape = function themeShape() {
  var shapeOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedShape = _objectSpread({}, ShapeAll);

  var keys = Object.keys(shapeOverrides);
  keys.forEach(function (shapeName) {
    if (Object.keys(ShapeTokensAll).indexOf(shapeName) === -1) {
      var overrideValue = shapeOverrides[shapeName];

      if (overrideValue && Object.values(ShapeTokensAll).indexOf(overrideValue) > -1) {
        themedShape[shapeName] = overrideValue;
      } else {
        console.error("Shape override must be one of the values in Shape Tokens - ignoring ".concat(shapeName, " override"));
      }
    } else {
      console.error("User may not override Shape Tokens: ".concat(Object.keys(ShapeTokensAll), " - ignoring ").concat(shapeName, " override"));
    }
  });
  return themedShape;
};

export { themeShape };
